<script lang="ts">
  import { onMount } from 'svelte';

  import { setLoginDialog } from './loginDialog';
  import CoreDialog from '../../components/core/CoreDialog.svelte';
  import { loginModel } from '../loginModel';
  let redirectURL = window.location.origin;

  let dialogRef: CoreDialog;

  const usernames = [
    'arthur',
    'egil',
    'hildebart',
    'karl',
    'lorang',
    'robinson',
    'bright',
  ];

  const logout = () => {
    loginModel.logout();
  };

  const onClose = () => {
    window.location.replace(redirectURL);
  };

  onMount(() => {
    setLoginDialog({
      openDialog: (redirectUrl: string) => {
        redirectURL = redirectUrl;
        dialogRef.show();
      },
    });
  });
</script>

<CoreDialog
  bind:this={dialogRef}
  label="Velg avatar"
  id="login-dialog"
  on:close={onClose}
>
  <button class="logoutbutton" on:click={logout}>Logg ut</button>
  <ul>
    {#each usernames as username}
      <li>
        <button
          class="userbutton"
          on:click={() => loginModel.loginTestUser(username)}>{username}</button
        >
      </li>
    {/each}
    <li />
  </ul>
  <button on:click={dialogRef.close}>Gå tilbake til app</button>
</CoreDialog>

<style>
  .logoutbutton {
    display: block;
    margin-bottom: 2rem;
  }

  .logoutbutton:disabled {
    opacity: 0.4;
  }

  ul {
    list-style: none;
    display: flex;
    flex-direction: column;
    padding: 0;
  }

  button {
    background-color: darkslateblue;
    color: lavenderblush;
    border: 2px solid lavenderblush;
    border-radius: 10rem;
    padding: 1rem 2rem;
  }

  .userbutton {
    width: 10rem;
    margin: 0.5rem;
    cursor: pointer;
    color: darkslateblue;
    background-color: transparent;
  }
</style>
